import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { Check } from "lucide-react";
import { tenantKpisQueryOptions } from "@/lib/queries";
import { useIamPermissionForTenant } from "@/features/auth/hooks/usePermissions";

export function OrgKpiAutosaveStatus({ tenantId }: { tenantId: string }) {
  const { t } = useTranslation();
  const canView = useIamPermissionForTenant(tenantId, "IDENTITY_HUB_VIEW_PAGE");
  const canManage = useIamPermissionForTenant(tenantId, "IDENTITY_HUB_UPDATE_TENANT");
  const canViewCatalog = canView || canManage;
  const { data } = useQuery({
    ...tenantKpisQueryOptions(tenantId),
    enabled: canViewCatalog && !!tenantId,
  });
  const visibleCount = data?.filter((row) => row.visible).length ?? 0;
  const hiddenCount = (data?.length ?? 0) - visibleCount;

  return (
    <span
      className="mr-auto flex items-center gap-1.5 text-xs text-muted-foreground"
      data-testid="org-kpi-autosave-status"
      aria-live="polite"
    >
      <Check className="size-3.5 text-success-subtle-foreground" aria-hidden />
      {[
        t("iam.orgDrawer.kpisFooter.autosave", "KPI changes save as you edit"),
        data
          ? t("iam.orgDrawer.kpisFooter.visibility", "{{visible}} visible, {{hidden}} hidden", {
              visible: visibleCount,
              hidden: hiddenCount,
            })
          : null,
      ]
        .filter(Boolean)
        .join(" · ")}
    </span>
  );
}
